import script from "./TabsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabsPage.vue?vue&type=script&setup=true&lang=ts"

import "./TabsPage.vue?vue&type=style&index=0&id=238f6474&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238f6474"]])

export default __exports__